import api from './api';

// Получение списка тестов
export const getAllTestsFetch = async (id) => {
    const { data } = await api.get('/v1/quizzes');
    return data;
};

//  редактирование теста
export const updateTestFetch = async (body) => {
    const { data } = await api.put('/v1/quiz', body);
    return data;
};

// Создание теста
export const createTestFetch = async (body) => {
    const { data } = await api.post('/v1/quiz', body);
    return data;
};
export const deleteTestFetch = async (id) => {
    const { data } = await api.delete('/v1/quiz', {
        params: { id },
    });
    return data;
};

// Дублирование теста
export const duplicateTestFetch = async (id) => {
    const { data } = await api.post('/v1/quiz/duplicate', { id });
    return data;
};

// Получение данных одного теста, общая информация
export const getTestFetch = async (id) => {
    const { data } = await api.get('/v1/quiz', {
        params: { id },
    });
    return data;
};

export const checkSessionFetch = async (id) => {
    const { data } = await api.get('/v1/session/check', {
        params: { id },
    });
    return data;
};

// Получение вопросов теста
export const getQuestionsFetch = async (id) => {
    const { data } = await api.get('/v1/quiz/questions', {
        params: { id },
    });
    return data;
};

// Создание вопроса, удаление вопроса, редактирование вопроса
export const fetchQuestion = async (body) => {
    const { data } = await api.post('/v1/quiz/question', body);
    return data;
};

export const updateQuestionFetch = async (body) => {
    const { data } = await api.put('/v1/quiz/question', body);
    return data;
};

export const duplicateQuestionFetch = async (body) => {
    const { data } = await api.post('/v1/quiz/question/duplicate', body);
    return data;
};

export const deleteQuestionFetch = async (question_id) => {
    const { data } = await api.delete('/v1/quiz/question', {
        params: question_id,
    });

    return data;
};

export const getQuestionFetch = async (question_id) => {
    const { data } = await api.get('/v1/quiz/question', {
        params: { question_id },
    });
    return data;
};

export const getAnswerIdFetch = async (body) => {
    const { data } = await api.post('/v1/quiz/answer', body);
    return data;
};

export const updateAnswerFetch = async (body) => {
    const { data } = await api.put('/v1/quiz/answer', body);
    return data;
};

export const deleteAnswerFetch = async (params) => {
    const { data } = await api.delete('/v1/quiz/answer', {
        params,
    });

    return data;
};

export const createExamFetch = async (body) => {
    const { data } = await api.post('/v1/quiz/exam', body);
    return data;
};

export const getExamQuestionFetch = async (id) => {
    const { data } = await api.get('/v1/quiz/exam/question', {
        params: { id },
    });
    return data;
};

export const getQuestionsInfoFetch = async (id) => {
    const { data } = await api.get('/v1/quiz/exam/questions', {
        params: { id },
    });
    return data;
};

export const submitAnswerFetch = async (body) => {
    const { data } = await api.post('/v1/quiz/exam/answer', body);
    return data;
};

export const finishExamFetch = async (body) => {
    const { data } = await api.put('/v1/quiz/exam', body);
    return data;
};

export const getExamResultFetch = async (id) => {
    const { data } = await api.get('/v1/quiz/exam', {
        params: { id },
    });
    return data;
};
